// بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ
//
// Shared Бриф design tokens (ported from the Claude Design brief palette).

import type { CSSProperties } from 'react';

export const C = {
  ink: '#1a1916',
  ink2: '#33312c',
  sub: '#5f5c55',
  muted: '#79766f',
  faint: '#b3afa6',
  faint2: '#a8a49c',
  sidebar: '#f6f4f1',
  line: '#ece9e4',
  line2: '#e3e0da',
  line3: '#e7e3dc',
  line4: '#f0ede8',
  userBubble: '#f1eee9',
  chipBg: '#f3f0eb',
  white: '#fff',
};

export const SANS = "'Golos Text', sans-serif";
export const MONO = "'JetBrains Mono', monospace";

export const mono = (extra: CSSProperties): CSSProperties => ({ fontFamily: MONO, ...extra });

export const FONT_ROOT: CSSProperties = {
  fontFamily: SANS,
  fontSize: 15,
  lineHeight: 1.5,
  color: C.ink,
  WebkitFontSmoothing: 'antialiased',
};
